import {
  Box,
  FormControl,
  Grid,
  InputAdornment,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomInputLabel,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  CustomTextFeildforFamily,
  StyledDateContainer,
} from "../../common/StyledComponents/StyledFields";
import { ValidationError, object, string } from "yup";
import styles from "../reportSection.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import { ClipLoader } from "react-spinners";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import { PersonSearch } from "@mui/icons-material";
import ReportsSearchDevotee from "../ReportsSearchDevotee/ReportsSearchDevotee";
import CustomDatePickerField from "../../CompactCustomComponents/CustomDatePickerField";
import CustomSelectField from "../../CompactCustomComponents/CustomSelectField";

interface ErrorMessageTypesBySignIn {
  signInName: string;
  searchByWeekly: string;
  searchByMonthly: string;
  searchByQuarterly: string;
  selectYear: string;
  searchYear: string;
}
const formFieldsSignIn = {
  signInName: "",
  searchByWeekly: dayjs().format("MM-DD-YYYY"),
  searchByMonthly: "",
  searchByQuarterly: "",
  selectYear: "",
  searchYear: "",
};
const SummaryBySignInName = ({ sendDataToParent, getReportData }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessageSignIn, setErrorMessageSignIn] =
    useState<ErrorMessageTypesBySignIn>({ ...formFieldsSignIn });

  const getFormattedEndDate = (startDate: any) => {
    return dayjs(startDate, "YYYY-MM-DD").add(1, "week").format("YYYY-MM-DD");
  };
  const [formDataSignIn, setFormDataSignIn] = useState({
    ...formFieldsSignIn,
    searchEndDate: getFormattedEndDate(formFieldsSignIn.searchByWeekly),
  });

  const [isFieldName, setIsFieldName] = useState("");
  const validationSchemaSignIn = object().shape({
    signInName: string().required("SignIn-Name is required"),
  });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const Quarterly = [
    { key: "Jan-March", value: 1 },
    { key: "April-June", value: 2 },
    { key: "July-Sept", value: 3 },
    { key: "Oct-Dec", value: 4 },
  ];

  const Years = [
    { key: "2014", value: 2014 },
    { key: "2015", value: 2015 },
    { key: "2016", value: 2016 },
    { key: "2017", value: 2017 },
    { key: "2018", value: 2018 },
    { key: "2019", value: 2019 },
    { key: "2020", value: 2020 },
    { key: "2021", value: 2021 },
    { key: "2022", value: 2022 },
    { key: "2023", value: 2023 },
    { key: "2024", value: 2024 },
  ];

  const monthsList = [
    { label: "Select", value: 13 },
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  const handleSearchByDateChange = (field: any, value: any) => {
    console.log(value);
    if (field === "searchByWeekly") {
      let formattedDate = dayjs(value, "MM/DD/YYYY");
      setFormDataSignIn({
        ...formDataSignIn,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM/DD/YYYY")
          : "",
      });
    } else {
      setFormDataSignIn({
        ...formDataSignIn,
        [field]: value,
      });
    }
    /* Enable and disable of fields accordingly */
    // if(field === "searchByWeekly") {
    //     setIsMonthSearch(true);
    //     setIsQuarterlySearch(true);
    // } else if(field === "searchByMonthly" || field === "selectYear") {
    //     setIsWeekSearch(true);
    //     setIsQuarterlySearch(true);
    // } else if(field === "searchByQuarterly" || field === "searchYear") {
    //     setIsWeekSearch(true);
    //     setIsMonthSearch(true);
    // }
    /* Enable and disable of fields accordingly */
    setIsFieldName(field);
  };

  const handleClear = () => {
    setFormDataSignIn({
      ...formDataSignIn,
      searchByWeekly: "",
      searchEndDate: "",
      signInName: "",
      searchByMonthly: "",
      searchByQuarterly: "",
      selectYear: "",
      searchYear: "",
    });
  };

  const getPoojaBookingSummarySignInReports = () => {
    const valueSelected: any = Object.entries(formDataSignIn).reduce(
      (a, [k, v]) => (v === "" ? a : (((a as any)[k] = v), a)),
      {}
    );
    let reqBody: any = {};
    let selectYear: number;
    let selectMonth: any;
    let selectQuarter: any;
    let startDate: any;
    let endDate: any;
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const quarterNames = ["Jan - Mar", "Apr - Jun", "Jul - Sep", "Oct - Nov"];
    reqBody.searchUserName = valueSelected["signInName"].toUpperCase();
    if (isFieldName === "searchByWeekly") {
      reqBody.searchStartDate = formDataSignIn.searchByWeekly;
      reqBody.searchEndDate = formDataSignIn.searchEndDate;
      startDate = dayjs(formDataSignIn.searchByWeekly).format("MM/DD/YYYY");
      endDate = dayjs(formDataSignIn.searchEndDate).format("MM/DD/YYYY");
    } else {
      reqBody.searchStartDate = formDataSignIn.searchByWeekly;
      reqBody.searchEndDate = formDataSignIn.searchEndDate;
      startDate = dayjs(formDataSignIn.searchByWeekly).format("MM/DD/YYYY");
      endDate = dayjs(formDataSignIn.searchEndDate).format("MM/DD/YYYY");
    }

    if (isFieldName === "searchByMonthly" || isFieldName === "selectYear") {
      selectYear = valueSelected["selectYear"];
      selectMonth = monthNames[valueSelected["searchByMonthly"]];
      let monthStartDate = dayjs(
        new Date(valueSelected["selectYear"], valueSelected["searchByMonthly"])
      ).format("YYYY-MM-DD");
      let monthEndDate = dayjs(
        new Date(
          valueSelected["selectYear"],
          valueSelected["searchByMonthly"] + 1,
          0
        )
      ).format("YYYY-MM-DD");
      reqBody.searchStartDate = monthStartDate;
      reqBody.searchEndDate = monthEndDate;
    } else if (
      isFieldName === "searchByQuarterly" ||
      isFieldName === "searchYear"
    ) {
      selectYear = valueSelected["searchYear"];
      selectQuarter = quarterNames[valueSelected["searchByQuarterly"]];
      let quarterStartDate = dayjs(
        new Date(
          valueSelected["searchYear"],
          valueSelected["searchByQuarterly"]
        )
      ).format("YYYY-MM-DD");
      let quarterEndDate = dayjs(
        new Date(
          valueSelected["searchYear"],
          valueSelected["searchByQuarterly"] + 3,
          0
        )
      ).format("YYYY-MM-DD");
      reqBody.searchStartDate = quarterStartDate;
      reqBody.searchEndDate = quarterEndDate;
    }
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:
        "/report-dashboard/reports/pooja/POOJA_BOOKING_SUMMARY_BY_SIGN_IN_NAME/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        const response = res.data;
        const resultData = response.map((value: any) => {
          return {
            "Name of Priest": `${value.firstname} ${value.middlename} ${value.lastname}`,
            "Number Of Poojas Booked": value.totalNumberOfPoojaBooked,
            "Total Time Booked": value.totalTimeBooked,
          };
        });
        getReportData(resultData);
        const totalPoojasBooked = resultData.reduce(
          (acc: any, curr: any) => acc + curr["Number Of Poojas Booked"],
          0
        );
        const totalTimeBooked = resultData.reduce(
          (acc: any, curr: any) => acc + curr["Total Time Booked"],
          0
        );
        sendDataToParent(true, { reqBody, totalPoojasBooked, totalTimeBooked });
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmitSignIn = async () => {
    const errors: ErrorMessageTypesBySignIn = {
      ...formFieldsSignIn,
    };
    try {
      // Validate the form data against the validation schema
      await validationSchemaSignIn.validate(formDataSignIn, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessageSignIn(errors);
      getPoojaBookingSummarySignInReports();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesBySignIn] = e.message;
          }
        });
      }
      setErrorMessageSignIn(errors);
    }
  };

  // Search Devotee setters and handlers
  const [openSearchDevotee, setOpenSearchDevotee] = useState(false);

  const handleOpenSearchDevoteeDialog = () => {
    setOpenSearchDevotee(true);
  };

  const handleClose = () => {
    setOpenSearchDevotee(false);
  };

  const hanldeSelectUser = (username: string) => {
    handleSearchByDateChange("signInName", username?.toUpperCase());
    handleClose();
  };

  const DatePickerWeekly = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formDataSignIn.searchByWeekly}
        handleDateChange={handleSearchByDateChange}
        errorMessage={undefined}
        name="searchByWeekly"
        format="MM-DD-YYYY"
        disableFuture
      />
    );
  };

  const MonthsDropdown = (): React.ReactElement => {
    return (
      <CustomSelectField
        id="grouped-select"
        handleDropdownChange={handleSearchByDateChange}
        errorMessage={""}
        dropDownList={monthsList}
        value={formDataSignIn.searchByMonthly}
        fieldName="Select month"
        placeholder={""}
        optionLabel="label"
        optionValue="label"
        overrideStyles={{ backgroundColor: "white" }}
      />
    );
  };


  const SelectYearDropdown = (): React.ReactElement => {
    return (
      <CustomSelectField
        id="grouped-select"
        handleDropdownChange={handleSearchByDateChange}
        errorMessage={""}
        dropDownList={Years}
        value={formDataSignIn.selectYear}
        fieldName="selectYear"
        placeholder={""}
        optionLabel="key"
        optionValue="value"
        overrideStyles={{ backgroundColor: "white" }}
      />
    );
  };

  const SelectQuarterDropdown = (): React.ReactElement => {
    return (
      <CustomSelectField
        id="grouped-select"
        handleDropdownChange={handleSearchByDateChange}
        errorMessage={""}
        dropDownList={Quarterly}
        value={formDataSignIn.searchByQuarterly}
        fieldName="searchByQuarterly"
        placeholder={""}
        optionLabel="key"
        optionValue="key"
        overrideStyles={{ backgroundColor: "white" }}
      />
    );
  };

  return (
    <Box sx={{ maxWidth: "450px" }}>
      <Grid container rowSpacing={"10px"} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Sign-In Name ", true)}
          <CustomTextFeildforFamily
            fullWidth
            required
            value={formDataSignIn.signInName}
            onChange={(e) => {
              const inputValue = e.target.value;
              setErrorMessageSignIn({ ...errorMessageSignIn, signInName: "" });
              handleSearchByDateChange("signInName", inputValue);
            }}
            className={`text_field compact_fields bg_white ${
              errorMessageSignIn.signInName
                ? styles.errorTextField
                : styles.dateFeild
            }`}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PersonSearch
                    sx={{ ml: "10px", cursor: "pointer", color: "#F05802" }}
                    onClick={handleOpenSearchDevoteeDialog}
                  />
                </InputAdornment>
              ),
            }}
            sx={{
              backgroundColor: "white !important",
              "& .MuiOutlinedInput-root": {
                pr: "7px",
              },
            }}
          />
          {errorMessageSignIn.signInName ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessageSignIn.signInName}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Grid
        container
        columnSpacing={"12px"}
        rowSpacing={"10px"}
        sx={{ marginTop: "0px" }}
      >
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Weekly", false)}
          {DatePickerWeekly()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Monthly", false)}
          {MonthsDropdown()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Select By Year", false)}
          {SelectYearDropdown()}
        </Grid>
      </Grid>
      <Grid
        container
        columnSpacing={"12px"}
        rowSpacing={"10px"}
        sx={{ marginTop: "0px" }}
      >
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Quarterly", false)}
          {SelectQuarterDropdown()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Year", false)}
          {SelectYearDropdown()}
        </Grid>
      </Grid>
      <Grid sx={{ marginTop: "20px", display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitSignIn}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
      {openSearchDevotee && (
        <ReportsSearchDevotee
          open={openSearchDevotee}
          handleClose={handleClose}
          hanldeSelectUser={hanldeSelectUser}
        />
      )}
    </Box>
  );
};
export default SummaryBySignInName;
